export const qldInstallsData = [
  {
    "name": "Acacia Ridge",
    "value": 21,
    "lat": -27.5857312,
    "lng": 153.025206
  },
  {
    "name": "Albany Creek",
    "value": 14,
    "lat": -27.353639,
    "lng": 152.96847128109638
  },
  {
    "name": "Alberton",
    "value": 2,
    "lat": -27.707543,
    "lng": 153.26622308788458
  },
  {
    "name": "Albion",
    "value": 6,
    "lat": -27.4302232,
    "lng": 153.0420578
  },
  {
    "name": "Alderley",
    "value": 2,
    "lat": -27.4258161,
    "lng": 153.002316
  },
  {
    "name": "Alexandra Headland",
    "value": 1,
    "lat": -26.669602,
    "lng": 153.1017526
  },
  {
    "name": "Alexandra Hills",
    "value": 12,
    "lat": -27.5232672,
    "lng": 153.2214907
  },
  {
    "name": "Algester",
    "value": 2,
    "lat": -27.6109526,
    "lng": 153.0315999
  },
  {
    "name": "Amberley",
    "value": 14,
    "lat": -27.62778345,
    "lng": 152.69545110840596
  },
  {
    "name": "Annerley",
    "value": 15,
    "lat": -27.5096348,
    "lng": 153.0327018
  },
  {
    "name": "Anstead",
    "value": 1,
    "lat": -27.538134999999997,
    "lng": 152.8666670892555
  },
  {
    "name": "Arana Hills",
    "value": 7,
    "lat": -27.394622499999997,
    "lng": 152.95350257595288
  },
  {
    "name": "Archerfield",
    "value": 2,
    "lat": -27.569485999999998,
    "lng": 153.00872543991687
  },
  {
    "name": "Armstrong Creek",
    "value": 2,
    "lat": -27.2187059,
    "lng": 152.8084209
  },
  {
    "name": "Aroona",
    "value": 3,
    "lat": -26.782604499999998,
    "lng": 153.1159507802334
  },
  {
    "name": "Arundel",
    "value": 13,
    "lat": -27.9360655,
    "lng": 153.3653514
  },
  {
    "name": "Ascot",
    "value": 8,
    "lat": -27.429703,
    "lng": 153.0638907278646
  },
  {
    "name": "Ashgrove",
    "value": 9,
    "lat": -27.44306,
    "lng": 152.9827648731527
  },
  {
    "name": "Ashmore",
    "value": 12,
    "lat": -27.9909266,
    "lng": 153.3770522
  },
  {
    "name": "Aspley",
    "value": 14,
    "lat": -27.3628522,
    "lng": 153.0164177
  },
  {
    "name": "Atkinsons Dam",
    "value": 1,
    "lat": -27.4138715,
    "lng": 152.42719678837207
  },
  {
    "name": "Auchenflower",
    "value": 2,
    "lat": -27.474471,
    "lng": 152.99491761550223
  },
  {
    "name": "Augustine Heights",
    "value": 9,
    "lat": -27.660553999999998,
    "lng": 152.8792482241784
  },
  {
    "name": "BURNSIDE",
    "value": 3,
    "lat": -26.6309735,
    "lng": 152.9411999
  },
  {
    "name": "Bahrs Scrub",
    "value": 5,
    "lat": -27.7375909,
    "lng": 153.1723698
  },
  {
    "name": "Bald Hills",
    "value": 7,
    "lat": -27.3107173,
    "lng": 153.0124269
  },
  {
    "name": "Balmoral",
    "value": 4,
    "lat": -27.456752,
    "lng": 153.06870764500266
  },
  {
    "name": "Bannockburn",
    "value": 1,
    "lat": -27.7614106,
    "lng": 153.190012
  },
  {
    "name": "Banya",
    "value": 35,
    "lat": -26.826168,
    "lng": 153.0429541
  },
  {
    "name": "Banyo",
    "value": 11,
    "lat": -27.3745474,
    "lng": 153.0774268
  },
  {
    "name": "Bardon",
    "value": 2,
    "lat": -27.459539499999998,
    "lng": 152.977650167374
  },
  {
    "name": "Baringa",
    "value": 15,
    "lat": -26.809219,
    "lng": 153.0801645988493
  },
  {
    "name": "Basin Pocket",
    "value": 1,
    "lat": -27.60135935,
    "lng": 152.76988862649512
  },
  {
    "name": "Battery Hill",
    "value": 1,
    "lat": -26.778891,
    "lng": 153.1299486
  },
  {
    "name": "Beaudesert",
    "value": 27,
    "lat": -27.9885617,
    "lng": 152.9961186
  },
  {
    "name": "Beenleigh",
    "value": 11,
    "lat": -27.7159492,
    "lng": 153.2022293
  },
  {
    "name": "Beerburrum",
    "value": 18,
    "lat": -26.9522294,
    "lng": 152.97160504610264
  },
  {
    "name": "Beerwah",
    "value": 13,
    "lat": -26.8573095,
    "lng": 152.9604136712077
  },
  {
    "name": "Belivah",
    "value": 4,
    "lat": -27.7586117,
    "lng": 153.1750031
  },
  {
    "name": "Bellara",
    "value": 1,
    "lat": -27.0628201,
    "lng": 153.1505009
  },
  {
    "name": "Bellbird Park",
    "value": 6,
    "lat": -27.6367635,
    "lng": 152.8886859
  },
  {
    "name": "Bellbowrie",
    "value": 3,
    "lat": -27.558120000000002,
    "lng": 152.886265052694
  },
  {
    "name": "Bellmere",
    "value": 1,
    "lat": -27.0890907,
    "lng": 152.9221627
  },
  {
    "name": "Bells Creek",
    "value": 8,
    "lat": -26.833572500000002,
    "lng": 153.07776476059644
  },
  {
    "name": "Belmont",
    "value": 2,
    "lat": -27.5147784,
    "lng": 153.1268563
  },
  {
    "name": "Benowa",
    "value": 7,
    "lat": -28.0041744,
    "lng": 153.3834595
  },
  {
    "name": "Berrinba",
    "value": 5,
    "lat": -27.652767,
    "lng": 153.0826433
  },
  {
    "name": "Bethania",
    "value": 8,
    "lat": -27.6918376,
    "lng": 153.1561448
  },
  {
    "name": "Biggera Waters",
    "value": 11,
    "lat": -27.9271595,
    "lng": 153.3983923
  },
  {
    "name": "Bilinga",
    "value": 9,
    "lat": -28.1606569,
    "lng": 153.50451923354836
  },
  {
    "name": "Birkdale",
    "value": 5,
    "lat": -27.4943324,
    "lng": 153.2151619
  },
  {
    "name": "Birnam",
    "value": 1,
    "lat": -27.4932795,
    "lng": 151.92426189405035
  },
  {
    "name": "Birtinya",
    "value": 8,
    "lat": -26.745231500000003,
    "lng": 153.1143476506357
  },
  {
    "name": "Bli Bli",
    "value": 7,
    "lat": -26.610295,
    "lng": 153.02183004880112
  },
  {
    "name": "Bokarina",
    "value": 2,
    "lat": -26.7388465,
    "lng": 153.12963784171598
  },
  {
    "name": "Bongaree",
    "value": 3,
    "lat": -27.0839863,
    "lng": 153.1594566
  },
  {
    "name": "Bonogin",
    "value": 2,
    "lat": -28.1447985,
    "lng": 153.35543833928892
  },
  {
    "name": "Boonah",
    "value": 2,
    "lat": -27.991084,
    "lng": 152.69621539044942
  },
  {
    "name": "Boondall",
    "value": 3,
    "lat": -27.3501466,
    "lng": 153.065654
  },
  {
    "name": "Booval",
    "value": 10,
    "lat": -27.5971279,
    "lng": 152.7928802
  },
  {
    "name": "Boronia Heights",
    "value": 3,
    "lat": -27.6879723,
    "lng": 153.0216096
  },
  {
    "name": "Bowen Hills",
    "value": 13,
    "lat": -27.4452317,
    "lng": 153.0375993
  },
  {
    "name": "Bracken Ridge",
    "value": 7,
    "lat": -27.3189512,
    "lng": 153.0390386
  },
  {
    "name": "Brassal",
    "value": 1,
    "lat": -27.5917295,
    "lng": 152.7365879
  },
  {
    "name": "Brassall",
    "value": 3,
    "lat": -27.5917295,
    "lng": 152.73658791093908
  },
  {
    "name": "Bray Park",
    "value": 12,
    "lat": -27.2925612,
    "lng": 152.9620596
  },
  {
    "name": "Brendale",
    "value": 14,
    "lat": -27.3173155,
    "lng": 152.9811617
  },
  {
    "name": "Bridgeman Downs",
    "value": 14,
    "lat": -27.3562082,
    "lng": 152.9944728
  },
  {
    "name": "Brighton",
    "value": 4,
    "lat": -27.2979603,
    "lng": 153.0581895
  },
  {
    "name": "Brisbane",
    "value": 27,
    "lat": -27.4689623,
    "lng": 153.0235009
  },
  {
    "name": "Brisbane Airport",
    "value": 7,
    "lat": -27.387621250000002,
    "lng": 153.12158203524928
  },
  {
    "name": "Brisbane CBD",
    "value": 1,
    "lat": -27.466829,
    "lng": 153.0273743
  },
  {
    "name": "Brisbane City",
    "value": 26,
    "lat": -27.468973849999998,
    "lng": 153.02348848660907
  },
  {
    "name": "Broadbeach",
    "value": 14,
    "lat": -28.0281465,
    "lng": 153.4312768805923
  },
  {
    "name": "Broadbeach Waters",
    "value": 8,
    "lat": -28.027217999999998,
    "lng": 153.41680319591157
  },
  {
    "name": "Broadwater",
    "value": 1,
    "lat": -28.660311,
    "lng": 151.87089482308392
  },
  {
    "name": "Brookfield",
    "value": 2,
    "lat": -27.488929,
    "lng": 152.9078820420315
  },
  {
    "name": "Brookwater",
    "value": 10,
    "lat": -27.656879,
    "lng": 152.89605951329673
  },
  {
    "name": "Browns Plains",
    "value": 3,
    "lat": -27.6621496,
    "lng": 153.0430484
  },
  {
    "name": "Buccan",
    "value": 4,
    "lat": -27.74194,
    "lng": 153.13913539213098
  },
  {
    "name": "Buddina",
    "value": 13,
    "lat": -26.693918,
    "lng": 153.13259534888175
  },
  {
    "name": "Buderim",
    "value": 16,
    "lat": -26.6857535,
    "lng": 153.0506403
  },
  {
    "name": "Bulcock Beach",
    "value": 1,
    "lat": -26.8074096,
    "lng": 153.1321022
  },
  {
    "name": "Bulimba",
    "value": 13,
    "lat": -27.4491865,
    "lng": 153.06048660600857
  },
  {
    "name": "Bundaberg",
    "value": 1,
    "lat": -24.8653253,
    "lng": 152.3516785
  },
  {
    "name": "Bundaberg West",
    "value": 1,
    "lat": -24.8724217,
    "lng": 152.3377928
  },
  {
    "name": "Bundall",
    "value": 7,
    "lat": -28.0112822,
    "lng": 153.4080912
  },
  {
    "name": "Bundamba",
    "value": 11,
    "lat": -27.6044365,
    "lng": 152.81148813595303
  },
  {
    "name": "Burleigh",
    "value": 1,
    "lat": -28.1021343,
    "lng": 153.4395799
  },
  {
    "name": "Burleigh Heads",
    "value": 17,
    "lat": -28.1021343,
    "lng": 153.4395799
  },
  {
    "name": "Burleigh Waters",
    "value": 10,
    "lat": -28.084812200000002,
    "lng": 153.43532167616718
  },
  {
    "name": "Burpengary",
    "value": 35,
    "lat": -27.1548645,
    "lng": 152.9708226
  },
  {
    "name": "Burpengary East",
    "value": 22,
    "lat": -27.1416507,
    "lng": 152.9997532
  },
  {
    "name": "Caboolture",
    "value": 43,
    "lat": -27.0839336,
    "lng": 152.9510863
  },
  {
    "name": "Caboolture South",
    "value": 5,
    "lat": -27.093826,
    "lng": 152.9502117
  },
  {
    "name": "Cairns North",
    "value": 1,
    "lat": -16.91225155,
    "lng": 145.7682767251833
  },
  {
    "name": "Calamvale",
    "value": 4,
    "lat": -27.6169467,
    "lng": 153.0495303
  },
  {
    "name": "Caloundra",
    "value": 25,
    "lat": -26.7981633,
    "lng": 153.1354434
  },
  {
    "name": "Caloundra West",
    "value": 3,
    "lat": -26.80301345,
    "lng": 153.10787845060162
  },
  {
    "name": "Camira",
    "value": 1,
    "lat": -27.634499,
    "lng": 152.9199269
  },
  {
    "name": "Camp Hill",
    "value": 17,
    "lat": -27.4942385,
    "lng": 153.0771926
  },
  {
    "name": "Campbells Pocket",
    "value": 1,
    "lat": -27.0778711,
    "lng": 152.8051617
  },
  {
    "name": "Cannon Hill",
    "value": 4,
    "lat": -27.472393,
    "lng": 153.09274228892946
  },
  {
    "name": "Canungra",
    "value": 2,
    "lat": -28.0171019,
    "lng": 153.165254
  },
  {
    "name": "Capalaba",
    "value": 4,
    "lat": -27.522037,
    "lng": 153.1918063
  },
  {
    "name": "Carbrook",
    "value": 7,
    "lat": -27.6759155,
    "lng": 153.236016
  },
  {
    "name": "Carina",
    "value": 6,
    "lat": -27.4872985,
    "lng": 153.1000362548637
  },
  {
    "name": "Carina Heights",
    "value": 2,
    "lat": -27.5014508,
    "lng": 153.0966984
  },
  {
    "name": "Carindale",
    "value": 6,
    "lat": -27.5032764,
    "lng": 153.1040678
  },
  {
    "name": "Carrara",
    "value": 12,
    "lat": -28.02077,
    "lng": 153.3683962
  },
  {
    "name": "Carseldine",
    "value": 5,
    "lat": -27.3470687,
    "lng": 153.0288395
  },
  {
    "name": "Cashmere",
    "value": 2,
    "lat": -27.2988918,
    "lng": 152.9122352
  },
  {
    "name": "Cawarral",
    "value": 1,
    "lat": -23.2543478,
    "lng": 150.6773192
  },
  {
    "name": "Cedar Creek",
    "value": 3,
    "lat": -27.8256448,
    "lng": 153.1800983
  },
  {
    "name": "Cedar Grove",
    "value": 1,
    "lat": -27.8598055,
    "lng": 152.97539512254576
  },
  {
    "name": "Chambers Flat",
    "value": 6,
    "lat": -27.748186,
    "lng": 153.0792864
  },
  {
    "name": "Chapel Hill",
    "value": 3,
    "lat": -27.4994565,
    "lng": 152.94975987019228
  },
  {
    "name": "Chelmer",
    "value": 3,
    "lat": -27.5122288,
    "lng": 152.9744075
  },
  {
    "name": "Chermside",
    "value": 14,
    "lat": -27.3863441,
    "lng": 153.0313687
  },
  {
    "name": "Chermside West",
    "value": 2,
    "lat": -27.3793434,
    "lng": 153.0186899
  },
  {
    "name": "Chevallum",
    "value": 9,
    "lat": -26.69833,
    "lng": 152.99278
  },
  {
    "name": "Chuwar",
    "value": 1,
    "lat": -27.554468999999997,
    "lng": 152.77302889285716
  },
  {
    "name": "Clagiraba",
    "value": 1,
    "lat": -27.9930785,
    "lng": 153.23337496448858
  },
  {
    "name": "Clayfield",
    "value": 4,
    "lat": -27.4182154,
    "lng": 153.0578224
  },
  {
    "name": "Clear Mountain",
    "value": 2,
    "lat": -27.3186825,
    "lng": 152.8909190183746
  },
  {
    "name": "Cleveland",
    "value": 12,
    "lat": -27.5262987,
    "lng": 153.2667298
  },
  {
    "name": "Clontarf",
    "value": 5,
    "lat": -27.247414,
    "lng": 153.082913
  },
  {
    "name": "Collingwood Park",
    "value": 6,
    "lat": -27.6245511,
    "lng": 152.8563239
  },
  {
    "name": "Coolangatta",
    "value": 12,
    "lat": -28.1703323,
    "lng": 153.53046372502652
  },
  {
    "name": "Coolum Beach",
    "value": 15,
    "lat": -26.53284,
    "lng": 153.0697205622449
  },
  {
    "name": "Coombabah",
    "value": 1,
    "lat": -27.9058415,
    "lng": 153.3722586
  },
  {
    "name": "Coomera",
    "value": 12,
    "lat": -27.9930182,
    "lng": 153.2234163
  },
  {
    "name": "Coominya",
    "value": 1,
    "lat": -27.392169,
    "lng": 152.5021029
  },
  {
    "name": "Coopers Plains",
    "value": 7,
    "lat": -27.5691456,
    "lng": 153.0337453
  },
  {
    "name": "Cooroy",
    "value": 2,
    "lat": -26.4176809,
    "lng": 152.9111931
  },
  {
    "name": "Coorparoo",
    "value": 11,
    "lat": -27.4962028,
    "lng": 153.0595973
  },
  {
    "name": "Corbould Park",
    "value": 6,
    "lat": -26.7974815,
    "lng": 153.06028936585696
  },
  {
    "name": "Corinda",
    "value": 7,
    "lat": -27.5430769,
    "lng": 152.9813705
  },
  {
    "name": "Cornubia",
    "value": 4,
    "lat": -27.6687965,
    "lng": 153.2014437
  },
  {
    "name": "Crestmead",
    "value": 13,
    "lat": -27.689416,
    "lng": 153.0914486
  },
  {
    "name": "Currimundi",
    "value": 6,
    "lat": -26.767334499999997,
    "lng": 153.12365805062012
  },
  {
    "name": "Currumbin",
    "value": 11,
    "lat": -28.1369655,
    "lng": 153.4799277
  },
  {
    "name": "Currumbin Valley",
    "value": 1,
    "lat": -28.204048,
    "lng": 153.398036376
  },
  {
    "name": "Currumbin Waters",
    "value": 3,
    "lat": -28.157286,
    "lng": 153.46106638938647
  },
  {
    "name": "D'Aguilar",
    "value": 5,
    "lat": -27.368541399999998,
    "lng": 152.77725522633204
  },
  {
    "name": "Daisy Hill",
    "value": 11,
    "lat": -27.643611,
    "lng": 153.1538113
  },
  {
    "name": "Dakabin",
    "value": 3,
    "lat": -27.2275114,
    "lng": 152.9845805
  },
  {
    "name": "Darra",
    "value": 4,
    "lat": -27.5659207,
    "lng": 152.9523917
  },
  {
    "name": "Dayboro",
    "value": 2,
    "lat": -27.1959179,
    "lng": 152.8245404
  },
  {
    "name": "Deagon",
    "value": 3,
    "lat": -27.327841499999998,
    "lng": 153.05892917165494
  },
  {
    "name": "Deception Bay",
    "value": 9,
    "lat": -27.1931635,
    "lng": 153.0274736
  },
  {
    "name": "Deebing Heights",
    "value": 5,
    "lat": -27.685892,
    "lng": 152.7620067261096
  },
  {
    "name": "Diddillibah",
    "value": 3,
    "lat": -26.6485865,
    "lng": 153.03738621676325
  },
  {
    "name": "Dinmore",
    "value": 2,
    "lat": -27.597476999999998,
    "lng": 152.832595848709
  },
  {
    "name": "Doolandella",
    "value": 4,
    "lat": -27.6170218,
    "lng": 152.982537
  },
  {
    "name": "Doonan",
    "value": 6,
    "lat": -26.44167,
    "lng": 153.01111
  },
  {
    "name": "Drewvale",
    "value": 2,
    "lat": -27.6499149,
    "lng": 153.0551353
  },
  {
    "name": "Dunwich",
    "value": 1,
    "lat": -27.4983605,
    "lng": 153.40493868537982
  },
  {
    "name": "Durack",
    "value": 5,
    "lat": -27.591662,
    "lng": 152.985997
  },
  {
    "name": "Dutton Park",
    "value": 7,
    "lat": -27.4948625,
    "lng": 153.02590098851567
  },
  {
    "name": "Eagle Farm",
    "value": 8,
    "lat": -27.4319245,
    "lng": 153.08987197863058
  },
  {
    "name": "Eagleby",
    "value": 5,
    "lat": -27.700935,
    "lng": 153.2126343
  },
  {
    "name": "East Banyo",
    "value": 1,
    "lat": -27.376989461105673,
    "lng": 153.07318317149563
  },
  {
    "name": "East Brisbane",
    "value": 4,
    "lat": -27.48588505,
    "lng": 153.0379847334293
  },
  {
    "name": "East Ipswich",
    "value": 4,
    "lat": -27.606491499999997,
    "lng": 152.77604114239534
  },
  {
    "name": "Eastern Heights",
    "value": 1,
    "lat": -27.626054500000002,
    "lng": 152.77699915570213
  },
  {
    "name": "Edens Landing",
    "value": 1,
    "lat": -27.703251,
    "lng": 153.1691263
  },
  {
    "name": "Eight Mile Plains",
    "value": 6,
    "lat": -27.5779184,
    "lng": 153.092299
  },
  {
    "name": "Elanora",
    "value": 12,
    "lat": -28.126998,
    "lng": 153.4591428
  },
  {
    "name": "Elimbah",
    "value": 7,
    "lat": -27.0113727,
    "lng": 152.9438
  },
  {
    "name": "Ellen Grove",
    "value": 2,
    "lat": -27.6184661,
    "lng": 152.9488045
  },
  {
    "name": "Enoggera",
    "value": 14,
    "lat": -27.4263185,
    "lng": 152.97432214664803
  },
  {
    "name": "Esk",
    "value": 1,
    "lat": -27.2398683,
    "lng": 152.4220194
  },
  {
    "name": "Eumundi",
    "value": 6,
    "lat": -26.4660905,
    "lng": 152.9563658227219
  },
  {
    "name": "Everton Hills",
    "value": 2,
    "lat": -27.3903467,
    "lng": 152.9690194
  },
  {
    "name": "Everton Park",
    "value": 6,
    "lat": -27.4064443,
    "lng": 152.9869559
  },
  {
    "name": "Fairfield",
    "value": 8,
    "lat": -27.5097306,
    "lng": 153.0279198
  },
  {
    "name": "Fernvale",
    "value": 3,
    "lat": -27.4561674,
    "lng": 152.652785
  },
  {
    "name": "Ferny Glen",
    "value": 1,
    "lat": -28.0749155,
    "lng": 153.15702497475348
  },
  {
    "name": "Ferny Grove",
    "value": 2,
    "lat": -27.4030685,
    "lng": 152.92787350899516
  },
  {
    "name": "Ferny Hills",
    "value": 5,
    "lat": -27.3941939,
    "lng": 152.9385882
  },
  {
    "name": "Fig Tree Pocket",
    "value": 1,
    "lat": -27.5292959,
    "lng": 152.9620948996951
  },
  {
    "name": "Fishermans Island",
    "value": 1,
    "lat": -27.465000266658308,
    "lng": 153.52068859081731
  },
  {
    "name": "Fitzgibbon",
    "value": 3,
    "lat": -27.3382423,
    "lng": 153.0333049
  },
  {
    "name": "Flagstone",
    "value": 15,
    "lat": -19.6080556,
    "lng": 146.7452778
  },
  {
    "name": "Flaxton",
    "value": 1,
    "lat": -26.6573646,
    "lng": 152.8781989
  },
  {
    "name": "Flinders View",
    "value": 8,
    "lat": -27.6516505,
    "lng": 152.78107882525356
  },
  {
    "name": "Forest Glen",
    "value": 2,
    "lat": -26.6768255,
    "lng": 153.0113878935557
  },
  {
    "name": "Forest Lake",
    "value": 3,
    "lat": -27.6228769,
    "lng": 152.9702476
  },
  {
    "name": "Fortitude Valley",
    "value": 8,
    "lat": -27.455896,
    "lng": 153.0339375
  },
  {
    "name": "Gagalba",
    "value": 2,
    "lat": -26.8354449,
    "lng": 153.051183
  },
  {
    "name": "Gailes",
    "value": 1,
    "lat": -27.61141,
    "lng": 152.9128309
  },
  {
    "name": "Gatton",
    "value": 1,
    "lat": -27.5615314,
    "lng": 152.2791353
  },
  {
    "name": "Gaythorne",
    "value": 2,
    "lat": -27.4192267,
    "lng": 152.9849743
  },
  {
    "name": "Geebung",
    "value": 5,
    "lat": -27.3703832,
    "lng": 153.0471643
  },
  {
    "name": "Gilston",
    "value": 1,
    "lat": -28.028847,
    "lng": 153.3128784
  },
  {
    "name": "Gislton",
    "value": 1,
    "lat": -22.1646782,
    "lng": 144.5844903
  },
  {
    "name": "Glass House Mountains",
    "value": 21,
    "lat": -26.8633248,
    "lng": 152.9941494048527
  },
  {
    "name": "Gleneagle",
    "value": 11,
    "lat": -27.9405645,
    "lng": 152.96203005196037
  },
  {
    "name": "Glenlogan",
    "value": 1,
    "lat": -27.834224,
    "lng": 153.00334083333334
  },
  {
    "name": "Glenview",
    "value": 4,
    "lat": -26.7657906,
    "lng": 153.0133981
  },
  {
    "name": "Gold Coast",
    "value": 1,
    "lat": -28.0023731,
    "lng": 153.4145987
  },
  {
    "name": "Golden Beach",
    "value": 3,
    "lat": -26.8156844,
    "lng": 153.1197588
  },
  {
    "name": "Goodna",
    "value": 4,
    "lat": -27.608852,
    "lng": 152.89277274438263
  },
  {
    "name": "Gordon Park",
    "value": 2,
    "lat": -27.4162777,
    "lng": 153.026166
  },
  {
    "name": "Graceville",
    "value": 4,
    "lat": -27.5214645,
    "lng": 152.98147866328415
  },
  {
    "name": "Grange",
    "value": 8,
    "lat": -27.4246675,
    "lng": 153.0154574
  },
  {
    "name": "Greenbank",
    "value": 19,
    "lat": -27.7317798,
    "lng": 152.9837006
  },
  {
    "name": "Greenslopes",
    "value": 13,
    "lat": -27.5088321,
    "lng": 153.0529626
  },
  {
    "name": "Griffin",
    "value": 4,
    "lat": -27.2634065,
    "lng": 153.0310025
  },
  {
    "name": "Guanaba",
    "value": 1,
    "lat": -27.9377318,
    "lng": 153.2403261
  },
  {
    "name": "Gumdale",
    "value": 2,
    "lat": -27.4951986,
    "lng": 153.1583601
  },
  {
    "name": "Gympie",
    "value": 4,
    "lat": -26.1900447,
    "lng": 152.6600256
  },
  {
    "name": "Hamilton",
    "value": 9,
    "lat": -20.358136950000002,
    "lng": 148.9521301512771
  },
  {
    "name": "Harrisville",
    "value": 1,
    "lat": -27.8098125,
    "lng": 152.67405825460867
  },
  {
    "name": "Hatton Vale",
    "value": 1,
    "lat": -27.5625865,
    "lng": 152.4781437
  },
  {
    "name": "Hawthorne",
    "value": 2,
    "lat": -27.4623063,
    "lng": 153.0598051
  },
  {
    "name": "Heathwood",
    "value": 10,
    "lat": -27.6389382,
    "lng": 152.9874053
  },
  {
    "name": "Helensvale",
    "value": 14,
    "lat": -27.9254255,
    "lng": 153.3389897
  },
  {
    "name": "Hemmant",
    "value": 9,
    "lat": -27.4505703,
    "lng": 153.1305205
  },
  {
    "name": "Hendra",
    "value": 3,
    "lat": -27.4175215,
    "lng": 153.07054479854912
  },
  {
    "name": "Heritage Park",
    "value": 2,
    "lat": -27.6830685,
    "lng": 153.0598889
  },
  {
    "name": "Herston",
    "value": 15,
    "lat": -27.449662500000002,
    "lng": 153.0237294176169
  },
  {
    "name": "Highgate Hill",
    "value": 4,
    "lat": -27.4878705,
    "lng": 153.0179821981132
  },
  {
    "name": "Highvale",
    "value": 1,
    "lat": -27.3703865,
    "lng": 152.811803
  },
  {
    "name": "Hillcrest",
    "value": 8,
    "lat": -27.6632327,
    "lng": 153.0272315
  },
  {
    "name": "Holland Park",
    "value": 7,
    "lat": -27.520083,
    "lng": 153.0729783
  },
  {
    "name": "Holland Park West",
    "value": 1,
    "lat": -27.528196,
    "lng": 153.0643664
  },
  {
    "name": "Hollywell",
    "value": 2,
    "lat": -27.895707,
    "lng": 153.3991084
  },
  {
    "name": "Holmview",
    "value": 1,
    "lat": -27.7046254,
    "lng": 153.1786453
  },
  {
    "name": "Hope Island",
    "value": 34,
    "lat": -27.8651137,
    "lng": 153.357731
  },
  {
    "name": "Illinbah",
    "value": 1,
    "lat": -28.1232641,
    "lng": 153.1429561
  },
  {
    "name": "Inala",
    "value": 6,
    "lat": -27.59854,
    "lng": 152.9720075
  },
  {
    "name": "Indooroopilly",
    "value": 5,
    "lat": -27.5065612,
    "lng": 152.98227768597326
  },
  {
    "name": "Ipswich",
    "value": 15,
    "lat": -27.6160323,
    "lng": 152.7608348
  },
  {
    "name": "Jacobs Well",
    "value": 5,
    "lat": -27.781996999999997,
    "lng": 153.35487817133128
  },
  {
    "name": "Jimboomba",
    "value": 20,
    "lat": -27.8318573,
    "lng": 153.0227538
  },
  {
    "name": "Jindalee",
    "value": 13,
    "lat": -27.535366500000002,
    "lng": 152.93785928009856
  },
  {
    "name": "Jones Hill",
    "value": 1,
    "lat": -26.2371615,
    "lng": 152.65987299148435
  },
  {
    "name": "Joyner",
    "value": 14,
    "lat": -27.272959,
    "lng": 152.9401453
  },
  {
    "name": "KURABY",
    "value": 2,
    "lat": -27.6047543,
    "lng": 153.0982186
  },
  {
    "name": "Kallangur",
    "value": 10,
    "lat": -27.2508529,
    "lng": 152.9927887
  },
  {
    "name": "Kangaroo Point",
    "value": 10,
    "lat": -27.473864,
    "lng": 153.0367846517436
  },
  {
    "name": "Karalee",
    "value": 1,
    "lat": -27.55908,
    "lng": 152.825285647295
  },
  {
    "name": "Karana Downs",
    "value": 3,
    "lat": -27.542751,
    "lng": 152.82334229951226
  },
  {
    "name": "Karawatha",
    "value": 2,
    "lat": -27.632223,
    "lng": 153.083054
  },
  {
    "name": "Karrabin",
    "value": 2,
    "lat": -27.6044244,
    "lng": 152.7090779
  },
  {
    "name": "Kawungan",
    "value": 1,
    "lat": -25.309433,
    "lng": 152.84364480686781
  },
  {
    "name": "Kedron",
    "value": 14,
    "lat": -27.4051171,
    "lng": 153.0332677
  },
  {
    "name": "Kelvin Grove",
    "value": 1,
    "lat": -27.450162,
    "lng": 153.01266953209569
  },
  {
    "name": "Kenilworth",
    "value": 1,
    "lat": -26.6352315,
    "lng": 152.6166379
  },
  {
    "name": "Kenmore",
    "value": 4,
    "lat": -27.515645,
    "lng": 152.9376610056806
  },
  {
    "name": "Kenmore Hills",
    "value": 1,
    "lat": -27.493915,
    "lng": 152.92841961135696
  },
  {
    "name": "Kensington Grove",
    "value": 1,
    "lat": -27.53472,
    "lng": 152.47289874870523
  },
  {
    "name": "Keperra",
    "value": 7,
    "lat": -27.4093318,
    "lng": 152.9588404
  },
  {
    "name": "Kholo",
    "value": 1,
    "lat": -27.525627,
    "lng": 152.7636695
  },
  {
    "name": "Kiels Mountain",
    "value": 2,
    "lat": -26.6572222,
    "lng": 153.0055556
  },
  {
    "name": "Kilcoy",
    "value": 4,
    "lat": -26.941717500000003,
    "lng": 152.5611569953678
  },
  {
    "name": "Kings Beach",
    "value": 3,
    "lat": -26.801990500000002,
    "lng": 153.14399503818737
  },
  {
    "name": "Kingsholme",
    "value": 4,
    "lat": -27.8182749,
    "lng": 153.2467766
  },
  {
    "name": "Kingston",
    "value": 15,
    "lat": -27.6557421,
    "lng": 153.1196351
  },
  {
    "name": "Kippa-Ring",
    "value": 7,
    "lat": -27.2251585,
    "lng": 153.083318
  },
  {
    "name": "Kipper-Ring",
    "value": 1,
    "lat": -27.2251585,
    "lng": 153.083318
  },
  {
    "name": "Knapp Creek",
    "value": 2,
    "lat": -28.126157499999998,
    "lng": 152.81130300596942
  },
  {
    "name": "Kuluin",
    "value": 2,
    "lat": -26.6578145,
    "lng": 153.05597224309594
  },
  {
    "name": "Kunda Park",
    "value": 2,
    "lat": -26.661275,
    "lng": 153.04011017305587
  },
  {
    "name": "Labrador",
    "value": 12,
    "lat": -27.9427642,
    "lng": 153.3987125
  },
  {
    "name": "Laidley",
    "value": 2,
    "lat": -27.6395345,
    "lng": 152.41328938320356
  },
  {
    "name": "Landsborough",
    "value": 16,
    "lat": -26.8078971,
    "lng": 152.9664042
  },
  {
    "name": "Larapinta",
    "value": 5,
    "lat": -27.640833,
    "lng": 153.006393
  },
  {
    "name": "Lawnton",
    "value": 12,
    "lat": -27.2826166,
    "lng": 152.9808511
  },
  {
    "name": "Leichhardt",
    "value": 1,
    "lat": -19.2200235,
    "lng": 139.9695409
  },
  {
    "name": "Lilywood",
    "value": 21,
    "lat": -27.1027791,
    "lng": 152.8985014
  },
  {
    "name": "Lilywood Caboolture",
    "value": 1,
    "lat": -27.1066984,
    "lng": 152.904133
  },
  {
    "name": "Lindum",
    "value": 1,
    "lat": -27.4419176,
    "lng": 153.1449418
  },
  {
    "name": "Little Mountain",
    "value": 8,
    "lat": -26.7828504,
    "lng": 153.0940075
  },
  {
    "name": "Logan Central",
    "value": 16,
    "lat": -27.6412988,
    "lng": 153.1072741
  },
  {
    "name": "Logan Reserve",
    "value": 17,
    "lat": -27.7170594,
    "lng": 153.1084184
  },
  {
    "name": "Logan Village",
    "value": 21,
    "lat": -27.7675482,
    "lng": 153.1070052
  },
  {
    "name": "Loganholme",
    "value": 6,
    "lat": -27.683054,
    "lng": 153.1894379
  },
  {
    "name": "Loganlea",
    "value": 11,
    "lat": -27.6731622,
    "lng": 153.137161
  },
  {
    "name": "Lota",
    "value": 3,
    "lat": -27.4679039,
    "lng": 153.1883924
  },
  {
    "name": "Lower Beechmont",
    "value": 1,
    "lat": -28.0476195,
    "lng": 153.2442522542732
  },
  {
    "name": "Lower Wonga",
    "value": 1,
    "lat": -26.110325000000003,
    "lng": 152.46961770303258
  },
  {
    "name": "Lowood",
    "value": 2,
    "lat": -27.4623314,
    "lng": 152.5805147
  },
  {
    "name": "Lutwyche",
    "value": 1,
    "lat": -27.420272,
    "lng": 153.0345604
  },
  {
    "name": "Lytton",
    "value": 12,
    "lat": -27.4145833,
    "lng": 153.15063881978966
  },
  {
    "name": "Macgregor",
    "value": 4,
    "lat": -27.5627144,
    "lng": 153.0719043
  },
  {
    "name": "Mackay",
    "value": 1,
    "lat": -21.141956,
    "lng": 149.1865149
  },
  {
    "name": "Mackenzie",
    "value": 6,
    "lat": -27.543318,
    "lng": 153.1248543
  },
  {
    "name": "Main Beach",
    "value": 24,
    "lat": -27.9787768,
    "lng": 153.4271228
  },
  {
    "name": "Maleny",
    "value": 4,
    "lat": -26.756741,
    "lng": 152.84242137688315
  },
  {
    "name": "Mango Hill",
    "value": 3,
    "lat": -27.2394237,
    "lng": 153.0346031
  },
  {
    "name": "Manly",
    "value": 4,
    "lat": -27.453347,
    "lng": 153.1840865329279
  },
  {
    "name": "Manly West",
    "value": 6,
    "lat": -27.4619537,
    "lng": 153.1692817
  },
  {
    "name": "Mansfield",
    "value": 3,
    "lat": -27.5314948,
    "lng": 153.1015318
  },
  {
    "name": "Marburg",
    "value": 1,
    "lat": -27.5620455,
    "lng": 152.5839921024758
  },
  {
    "name": "Marcoola",
    "value": 8,
    "lat": -26.5922485,
    "lng": 153.07979856090444
  },
  {
    "name": "Marcus Beach",
    "value": 1,
    "lat": -26.4532405,
    "lng": 153.0976452
  },
  {
    "name": "Margate",
    "value": 16,
    "lat": -27.244011,
    "lng": 153.1074473
  },
  {
    "name": "Maroochydore",
    "value": 20,
    "lat": -26.6556523,
    "lng": 153.0946684
  },
  {
    "name": "Marsden",
    "value": 19,
    "lat": -27.6755473,
    "lng": 153.103837
  },
  {
    "name": "Maryborough",
    "value": 1,
    "lat": -25.537583,
    "lng": 152.7019182
  },
  {
    "name": "Maudsland",
    "value": 1,
    "lat": -27.9280622,
    "lng": 153.2823303
  },
  {
    "name": "McDowall",
    "value": 2,
    "lat": -27.3886299,
    "lng": 152.9967591
  },
  {
    "name": "Meadowbrook",
    "value": 12,
    "lat": -27.6624666,
    "lng": 153.1415558
  },
  {
    "name": "Meridan Plains",
    "value": 12,
    "lat": -26.7625195,
    "lng": 153.08618811092003
  },
  {
    "name": "Mermaid Beach",
    "value": 6,
    "lat": -28.048386999999998,
    "lng": 153.43654687184784
  },
  {
    "name": "Mermaid Waters",
    "value": 10,
    "lat": -28.052458,
    "lng": 153.42189224804105
  },
  {
    "name": "Merrimac",
    "value": 5,
    "lat": -28.0514674,
    "lng": 153.37399715256234
  },
  {
    "name": "Miami",
    "value": 11,
    "lat": -28.069175,
    "lng": 153.43508242648818
  },
  {
    "name": "Miles",
    "value": 1,
    "lat": -26.6596187,
    "lng": 150.189591
  },
  {
    "name": "Milton",
    "value": 2,
    "lat": -27.469474499999997,
    "lng": 153.00552966455007
  },
  {
    "name": "Minyama",
    "value": 2,
    "lat": -26.696068500000003,
    "lng": 153.12212166745655
  },
  {
    "name": "Mitchelton",
    "value": 9,
    "lat": -27.4116762,
    "lng": 152.9759985
  },
  {
    "name": "Moffat Beach",
    "value": 1,
    "lat": -26.7907402,
    "lng": 153.1421093
  },
  {
    "name": "Moggill",
    "value": 1,
    "lat": -27.583271,
    "lng": 152.8879224817976
  },
  {
    "name": "Molendinar",
    "value": 5,
    "lat": -27.9745778,
    "lng": 153.3754344
  },
  {
    "name": "Mons",
    "value": 2,
    "lat": -26.69,
    "lng": 153.02611
  },
  {
    "name": "Montville",
    "value": 1,
    "lat": -26.6971025,
    "lng": 152.8940371
  },
  {
    "name": "Mooloolaba",
    "value": 17,
    "lat": -26.6852565,
    "lng": 153.1131848665925
  },
  {
    "name": "Moorooka",
    "value": 5,
    "lat": -27.5357999,
    "lng": 153.0201543
  },
  {
    "name": "Morayfield",
    "value": 59,
    "lat": -27.1102549,
    "lng": 152.948924
  },
  {
    "name": "Moree",
    "value": 1,
    "lat": -23.6761311,
    "lng": 146.5921928
  },
  {
    "name": "Morningside",
    "value": 19,
    "lat": -27.4615955,
    "lng": 153.07544554540004
  },
  {
    "name": "Mount Coot-tha",
    "value": 1,
    "lat": -27.47608,
    "lng": 152.9495974
  },
  {
    "name": "Mount Cotton",
    "value": 4,
    "lat": -27.597900449999997,
    "lng": 153.2290385
  },
  {
    "name": "Mount Crosby",
    "value": 4,
    "lat": -27.532411500000002,
    "lng": 152.7905343336022
  },
  {
    "name": "Mount Gravatt",
    "value": 15,
    "lat": -27.56272235,
    "lng": 153.08212459593827
  },
  {
    "name": "Mount Gravatt East",
    "value": 8,
    "lat": -27.5326267,
    "lng": 153.0830705
  },
  {
    "name": "Mount Nathan",
    "value": 1,
    "lat": -27.9952778,
    "lng": 153.2725
  },
  {
    "name": "Mount Samson",
    "value": 2,
    "lat": -27.299502500000003,
    "lng": 152.84750994142377
  },
  {
    "name": "Mountain Creek",
    "value": 7,
    "lat": -26.6998495,
    "lng": 153.10134882614346
  },
  {
    "name": "Mt Cotton",
    "value": 1,
    "lat": -27.6395682,
    "lng": 153.2246375106644
  },
  {
    "name": "Mudgeeraba",
    "value": 5,
    "lat": -28.083126749999998,
    "lng": 153.35853539059002
  },
  {
    "name": "Mudjimba",
    "value": 3,
    "lat": -26.618555,
    "lng": 153.09666874931378
  },
  {
    "name": "Mundoolan",
    "value": 1,
    "lat": -22.1646782,
    "lng": 144.5844903
  },
  {
    "name": "Mundoolun",
    "value": 1,
    "lat": -27.8942895,
    "lng": 153.07207410777352
  },
  {
    "name": "Munruben",
    "value": 2,
    "lat": -27.7462512,
    "lng": 153.0271901
  },
  {
    "name": "Murarrie",
    "value": 2,
    "lat": -27.44912,
    "lng": 153.1060533761757
  },
  {
    "name": "Murrumba Downs",
    "value": 16,
    "lat": -27.2645498,
    "lng": 153.0065013
  },
  {
    "name": "Nambour",
    "value": 14,
    "lat": -26.6257326,
    "lng": 152.959953
  },
  {
    "name": "Narangba",
    "value": 22,
    "lat": -27.2027145,
    "lng": 152.9592212
  },
  {
    "name": "Narangba Valley",
    "value": 1,
    "lat": -27.1856648,
    "lng": 152.9341032
  },
  {
    "name": "Nathan",
    "value": 6,
    "lat": -27.548375,
    "lng": 153.0474942
  },
  {
    "name": "Nerang",
    "value": 17,
    "lat": -27.9896566,
    "lng": 153.3365942
  },
  {
    "name": "New Beith",
    "value": 8,
    "lat": -27.761777000000002,
    "lng": 152.94009253395734
  },
  {
    "name": "New Chum",
    "value": 1,
    "lat": -27.6173105,
    "lng": 152.8349947
  },
  {
    "name": "New Farm",
    "value": 4,
    "lat": -27.466589,
    "lng": 153.04693631358884
  },
  {
    "name": "New Italy",
    "value": 1,
    "lat": -27.466589,
    "lng": 153.04693631358884
  },
  {
    "name": "Newmarket",
    "value": 4,
    "lat": -27.4365249,
    "lng": 153.0069328
  },
  {
    "name": "Newport",
    "value": 4,
    "lat": -27.2124695,
    "lng": 153.0858426
  },
  {
    "name": "Newstead",
    "value": 2,
    "lat": -27.4483345,
    "lng": 153.0461534314082
  },
  {
    "name": "Newtown",
    "value": 1,
    "lat": -27.5553505,
    "lng": 151.93041110229922
  },
  {
    "name": "Nimbin",
    "value": 2,
    "lat": -27.383172,
    "lng": 152.9784989
  },
  {
    "name": "Ninderry",
    "value": 1,
    "lat": -26.539027,
    "lng": 152.975576
  },
  {
    "name": "Ningi",
    "value": 1,
    "lat": -27.0617509,
    "lng": 153.07864
  },
  {
    "name": "Nirimba",
    "value": 19,
    "lat": -26.8202599,
    "lng": 153.0525756
  },
  {
    "name": "Noosa Heads",
    "value": 15,
    "lat": -26.40014,
    "lng": 153.0910490046545
  },
  {
    "name": "Noosaville",
    "value": 12,
    "lat": -26.4248421,
    "lng": 153.057509990727
  },
  {
    "name": "Norman Park",
    "value": 6,
    "lat": -27.480455,
    "lng": 153.0641069
  },
  {
    "name": "North Arm",
    "value": 1,
    "lat": -26.5156274,
    "lng": 152.9543822
  },
  {
    "name": "North Lakes",
    "value": 12,
    "lat": -27.2381221,
    "lng": 153.017699
  },
  {
    "name": "North Maclean",
    "value": 18,
    "lat": -27.7768283,
    "lng": 153.0099871
  },
  {
    "name": "Northgate",
    "value": 2,
    "lat": -27.3908162,
    "lng": 153.0693526
  },
  {
    "name": "Nudgee",
    "value": 3,
    "lat": -27.3660824,
    "lng": 153.0834119
  },
  {
    "name": "Numinbah Valley",
    "value": 1,
    "lat": -28.1518255,
    "lng": 153.2224557
  },
  {
    "name": "Nundah",
    "value": 5,
    "lat": -27.4012298,
    "lng": 153.0603789
  },
  {
    "name": "Ocean View",
    "value": 2,
    "lat": -27.136822,
    "lng": 152.8076347
  },
  {
    "name": "Ormeau",
    "value": 27,
    "lat": -27.774813,
    "lng": 153.25208152006778
  },
  {
    "name": "Ormiston",
    "value": 3,
    "lat": -27.5145911,
    "lng": 153.2558464
  },
  {
    "name": "Orrmeau",
    "value": 2,
    "lat": -22.1646782,
    "lng": 144.5844903
  },
  {
    "name": "Owanyilla",
    "value": 1,
    "lat": -25.6737685,
    "lng": 152.6185479
  },
  {
    "name": "Oxenford",
    "value": 9,
    "lat": -27.9015337,
    "lng": 153.2997577
  },
  {
    "name": "Oxley",
    "value": 4,
    "lat": -27.5564622,
    "lng": 152.9743667
  },
  {
    "name": "Pacific Paradise",
    "value": 3,
    "lat": -26.624715000000002,
    "lng": 153.07068958864542
  },
  {
    "name": "Pacific Pines",
    "value": 2,
    "lat": -27.9382489,
    "lng": 153.3092643
  },
  {
    "name": "Paddington",
    "value": 3,
    "lat": -27.460752499999998,
    "lng": 153.00010828692655
  },
  {
    "name": "Palen Creek",
    "value": 1,
    "lat": -28.288552,
    "lng": 152.7957577
  },
  {
    "name": "Pallara",
    "value": 7,
    "lat": -27.620834,
    "lng": 153.005005
  },
  {
    "name": "Palm Beach",
    "value": 41,
    "lat": -28.1155325,
    "lng": 153.45839363242405
  },
  {
    "name": "Palmview",
    "value": 21,
    "lat": -26.748479500000002,
    "lng": 153.05377933207325
  },
  {
    "name": "Palmwoods",
    "value": 10,
    "lat": -26.692799,
    "lng": 152.96086073528522
  },
  {
    "name": "Paradise Point",
    "value": 3,
    "lat": -27.8862745,
    "lng": 153.3957227
  },
  {
    "name": "Park Ridge",
    "value": 29,
    "lat": -27.6987848,
    "lng": 153.0481122
  },
  {
    "name": "Park Ridge South",
    "value": 3,
    "lat": -27.727592,
    "lng": 153.0356009
  },
  {
    "name": "Parkinson",
    "value": 16,
    "lat": -27.6357372,
    "lng": 153.0300028
  },
  {
    "name": "Parkwood",
    "value": 6,
    "lat": -27.9519232,
    "lng": 153.3471401
  },
  {
    "name": "Peachester",
    "value": 2,
    "lat": -26.8452935,
    "lng": 152.8837795
  },
  {
    "name": "Peak Crossing",
    "value": 1,
    "lat": -27.7834527,
    "lng": 152.7295353
  },
  {
    "name": "Peregian Beach",
    "value": 5,
    "lat": -26.4810973,
    "lng": 153.0961801
  },
  {
    "name": "Peregian Springs",
    "value": 3,
    "lat": -26.4949465,
    "lng": 153.0681201
  },
  {
    "name": "Petrie",
    "value": 6,
    "lat": -27.2647744,
    "lng": 152.9659901
  },
  {
    "name": "Petrie Terrace",
    "value": 6,
    "lat": -27.461793,
    "lng": 153.0133632713111
  },
  {
    "name": "Pimpama",
    "value": 27,
    "lat": -27.8161679,
    "lng": 153.2924022
  },
  {
    "name": "Pinjarra Hills",
    "value": 1,
    "lat": -27.538146,
    "lng": 152.9114761
  },
  {
    "name": "Pinkenba",
    "value": 10,
    "lat": -27.394503,
    "lng": 153.14308374799714
  },
  {
    "name": "Plainland",
    "value": 5,
    "lat": -27.5655149,
    "lng": 152.4226398
  },
  {
    "name": "Point Arkwright",
    "value": 1,
    "lat": -26.5466605,
    "lng": 153.0982335422131
  },
  {
    "name": "Pomona",
    "value": 2,
    "lat": -26.3662684,
    "lng": 152.8571354
  },
  {
    "name": "Port of Brisbane",
    "value": 3,
    "lat": -27.3823606,
    "lng": 153.1693616
  },
  {
    "name": "Prenzlau",
    "value": 1,
    "lat": -27.5270795,
    "lng": 152.51477876185004
  },
  {
    "name": "Raceview",
    "value": 3,
    "lat": -27.6360785,
    "lng": 152.7773823
  },
  {
    "name": "Red Hill",
    "value": 1,
    "lat": -27.4545228,
    "lng": 153.0071405
  },
  {
    "name": "Redbank",
    "value": 2,
    "lat": -27.6513182,
    "lng": 152.8479458
  },
  {
    "name": "Redbank Plains",
    "value": 16,
    "lat": -27.6513182,
    "lng": 152.8479458
  },
  {
    "name": "Redcliffe",
    "value": 26,
    "lat": -27.2268785,
    "lng": 153.1129973
  },
  {
    "name": "Redland Bay",
    "value": 20,
    "lat": -27.6126945,
    "lng": 153.3036238
  },
  {
    "name": "Reedy Creek",
    "value": 7,
    "lat": -28.1205111,
    "lng": 153.4032864
  },
  {
    "name": "Regents Park",
    "value": 7,
    "lat": -27.674787,
    "lng": 153.0428551
  },
  {
    "name": "Richlands",
    "value": 6,
    "lat": -27.5949839,
    "lng": 152.9538031
  },
  {
    "name": "Ripley",
    "value": 23,
    "lat": -27.6712978,
    "lng": 152.7804522
  },
  {
    "name": "Riverview",
    "value": 11,
    "lat": -27.5949777,
    "lng": 152.850542
  },
  {
    "name": "Robina",
    "value": 15,
    "lat": -28.0705635,
    "lng": 153.39163957932692
  },
  {
    "name": "Rochedale",
    "value": 23,
    "lat": -27.6009655,
    "lng": 153.1283725
  },
  {
    "name": "Rochedale South",
    "value": 12,
    "lat": -27.6009655,
    "lng": 153.1283725
  },
  {
    "name": "Rocklea",
    "value": 6,
    "lat": -27.5482033,
    "lng": 153.0115871
  },
  {
    "name": "Rosemount",
    "value": 1,
    "lat": -26.62333,
    "lng": 153.00111
  },
  {
    "name": "Rothwell",
    "value": 7,
    "lat": -27.2153199,
    "lng": 153.0478394
  },
  {
    "name": "Runaway Bay",
    "value": 7,
    "lat": -27.9122419,
    "lng": 153.4029513
  },
  {
    "name": "Runcorn",
    "value": 1,
    "lat": -27.611014349999998,
    "lng": 153.0721177480268
  },
  {
    "name": "Running Creek",
    "value": 3,
    "lat": -28.271721,
    "lng": 152.90162225469484
  },
  {
    "name": "Salisbury",
    "value": 16,
    "lat": -27.5543181,
    "lng": 153.0265175
  },
  {
    "name": "Samford Valley",
    "value": 4,
    "lat": -27.3708125,
    "lng": 152.85580726028198
  },
  {
    "name": "Samford Village",
    "value": 4,
    "lat": -27.37355,
    "lng": 152.8847056434017
  },
  {
    "name": "Sandgate",
    "value": 3,
    "lat": -27.3222807,
    "lng": 153.0695096
  },
  {
    "name": "Sandstone Point",
    "value": 1,
    "lat": -27.0807672,
    "lng": 153.126773
  },
  {
    "name": "Scarborough",
    "value": 5,
    "lat": -27.2062945,
    "lng": 153.1139465
  },
  {
    "name": "Seven Hills",
    "value": 1,
    "lat": -27.480314,
    "lng": 153.0776578
  },
  {
    "name": "Seventeen Mile Rocks",
    "value": 1,
    "lat": -27.5495466,
    "lng": 152.9579475
  },
  {
    "name": "Shailer Park",
    "value": 7,
    "lat": -27.6524382,
    "lng": 153.1727858
  },
  {
    "name": "Sherwood",
    "value": 8,
    "lat": -27.530861,
    "lng": 152.9826097
  },
  {
    "name": "Shorncliffe",
    "value": 4,
    "lat": -27.3269657,
    "lng": 153.0801166
  },
  {
    "name": "Silkstone",
    "value": 1,
    "lat": -27.6237049,
    "lng": 152.7913071
  },
  {
    "name": "Sippy Downs",
    "value": 13,
    "lat": -26.7257935,
    "lng": 153.07837089055133
  },
  {
    "name": "Slacks Creek",
    "value": 8,
    "lat": -27.6421532,
    "lng": 153.141545
  },
  {
    "name": "Souhtport",
    "value": 1,
    "lat": -22.1646782,
    "lng": 144.5844903
  },
  {
    "name": "South Brisbane",
    "value": 36,
    "lat": -27.47564805,
    "lng": 153.0203484303831
  },
  {
    "name": "South Maclean",
    "value": 10,
    "lat": -27.7890909,
    "lng": 153.0106015
  },
  {
    "name": "South Ripley",
    "value": 15,
    "lat": -27.7170573,
    "lng": 152.8251117
  },
  {
    "name": "Southport",
    "value": 48,
    "lat": -27.9687807,
    "lng": 153.4066696
  },
  {
    "name": "Southside",
    "value": 2,
    "lat": -26.208727,
    "lng": 152.64968136295772
  },
  {
    "name": "Spring Hill",
    "value": 8,
    "lat": -27.4614416,
    "lng": 153.0257338
  },
  {
    "name": "Spring Mountain",
    "value": 8,
    "lat": -27.7180345,
    "lng": 152.8789362
  },
  {
    "name": "Springfield",
    "value": 5,
    "lat": -27.6540497,
    "lng": 152.908847
  },
  {
    "name": "Springfield Central",
    "value": 10,
    "lat": -27.6861177,
    "lng": 152.9037832
  },
  {
    "name": "Springfield Lakes",
    "value": 2,
    "lat": -27.6826685,
    "lng": 152.9202698
  },
  {
    "name": "Springwood",
    "value": 4,
    "lat": -27.6188844,
    "lng": 153.1308699
  },
  {
    "name": "St Lucia",
    "value": 15,
    "lat": -27.49741805,
    "lng": 153.01316662434917
  },
  {
    "name": "Stafford",
    "value": 8,
    "lat": -27.4096212,
    "lng": 153.0138783
  },
  {
    "name": "Stafford Heights",
    "value": 3,
    "lat": -27.3961056,
    "lng": 153.0110337
  },
  {
    "name": "Stanthorpe",
    "value": 1,
    "lat": -28.6559947,
    "lng": 151.9338265
  },
  {
    "name": "Stapylton",
    "value": 25,
    "lat": -27.73143105,
    "lng": 153.24603398535044
  },
  {
    "name": "Stockleigh",
    "value": 2,
    "lat": -27.7732857,
    "lng": 153.0573137
  },
  {
    "name": "Stones Corner",
    "value": 2,
    "lat": -27.499255,
    "lng": 153.0443195
  },
  {
    "name": "Strathpine",
    "value": 1,
    "lat": -27.3099861,
    "lng": 152.9905347
  },
  {
    "name": "Stretton",
    "value": 1,
    "lat": -27.6126833,
    "lng": 153.068394
  },
  {
    "name": "Sunnybank",
    "value": 8,
    "lat": -27.5752834,
    "lng": 153.0557235
  },
  {
    "name": "Sunnybank Hills",
    "value": 5,
    "lat": -27.5991376,
    "lng": 153.0486182
  },
  {
    "name": "Sunrise Beach",
    "value": 12,
    "lat": -26.4161989,
    "lng": 153.1077071
  },
  {
    "name": "Sunshine Beach",
    "value": 3,
    "lat": -26.8156844,
    "lng": 153.1197588
  },
  {
    "name": "Sunshine Coast",
    "value": 1,
    "lat": -26.6544338,
    "lng": 153.0933668
  },
  {
    "name": "Surfers Paradise",
    "value": 35,
    "lat": -27.9989899,
    "lng": 153.42398
  },
  {
    "name": "Swanbank",
    "value": 1,
    "lat": -27.6612741,
    "lng": 152.8241225
  },
  {
    "name": "Taigum",
    "value": 12,
    "lat": -27.3419188,
    "lng": 153.0476946
  },
  {
    "name": "Tallai",
    "value": 4,
    "lat": -28.0730154,
    "lng": 153.3330328
  },
  {
    "name": "Tallebudgera",
    "value": 2,
    "lat": -28.150904500000003,
    "lng": 153.42054221547048
  },
  {
    "name": "Tallebudgera Valley",
    "value": 7,
    "lat": -28.1826765,
    "lng": 153.363230986411
  },
  {
    "name": "Tallegalla",
    "value": 2,
    "lat": -27.5873386,
    "lng": 152.5549438
  },
  {
    "name": "Tamborine",
    "value": 3,
    "lat": -27.9318008,
    "lng": 153.17025019029086
  },
  {
    "name": "Tamborine Mountain",
    "value": 6,
    "lat": -27.9318008,
    "lng": 153.17025019029086
  },
  {
    "name": "Tanawha",
    "value": 4,
    "lat": -26.71528,
    "lng": 153.03444
  },
  {
    "name": "Tansey",
    "value": 1,
    "lat": -26.0414,
    "lng": 152.0493079
  },
  {
    "name": "Taringa",
    "value": 2,
    "lat": -27.4952415,
    "lng": 152.9854034831622
  },
  {
    "name": "Tarragindi",
    "value": 18,
    "lat": -27.5266462,
    "lng": 153.0434187
  },
  {
    "name": "Teneriffe",
    "value": 5,
    "lat": -27.4561795,
    "lng": 153.04757476785716
  },
  {
    "name": "Tennyson",
    "value": 6,
    "lat": -27.525635700000002,
    "lng": 153.0072604631397
  },
  {
    "name": "Tewantin",
    "value": 2,
    "lat": -26.3920057,
    "lng": 153.0391832
  },
  {
    "name": "The Gap",
    "value": 4,
    "lat": -27.4436425,
    "lng": 152.9453604729064
  },
  {
    "name": "Thornlands",
    "value": 14,
    "lat": -27.558201,
    "lng": 153.2666265
  },
  {
    "name": "Tiaro",
    "value": 2,
    "lat": -25.728801500000003,
    "lng": 152.59872958336325
  },
  {
    "name": "Tinana",
    "value": 1,
    "lat": -25.5448585,
    "lng": 152.6594348
  },
  {
    "name": "Tinbeerwah",
    "value": 1,
    "lat": -26.4034205,
    "lng": 152.9728381
  },
  {
    "name": "Tingalpa",
    "value": 10,
    "lat": -27.473625,
    "lng": 153.12505373792902
  },
  {
    "name": "Tivoli",
    "value": 2,
    "lat": -27.5864835,
    "lng": 152.77575430426484
  },
  {
    "name": "Toorbul",
    "value": 1,
    "lat": -27.0328051,
    "lng": 153.0985191
  },
  {
    "name": "Toowong",
    "value": 19,
    "lat": -27.478974,
    "lng": 152.98532411078423
  },
  {
    "name": "Tugun",
    "value": 6,
    "lat": -28.148820999999998,
    "lng": 153.49040179094828
  },
  {
    "name": "Tumbulgum",
    "value": 1,
    "lat": -22.1646782,
    "lng": 144.5844903
  },
  {
    "name": "Tweed Heads",
    "value": 1,
    "lat": -27.92367676267119,
    "lng": 153.20724924364077
  },
  {
    "name": "Twin Waters",
    "value": 1,
    "lat": -26.6297315,
    "lng": 153.0809269
  },
  {
    "name": "Underwood",
    "value": 4,
    "lat": -27.6070295,
    "lng": 153.1123282
  },
  {
    "name": "Upper Brookfield",
    "value": 2,
    "lat": -27.473147,
    "lng": 152.8424587680464
  },
  {
    "name": "Upper Caboolture",
    "value": 12,
    "lat": -27.1162759,
    "lng": 152.9014219
  },
  {
    "name": "Upper Coomera",
    "value": 14,
    "lat": -27.8529809,
    "lng": 153.2982761
  },
  {
    "name": "Upper Kedron",
    "value": 9,
    "lat": -27.419212,
    "lng": 152.91967429098054
  },
  {
    "name": "Upper Mount Gravatt",
    "value": 4,
    "lat": -27.56272235,
    "lng": 153.08212459593827
  },
  {
    "name": "Varsity Lakes",
    "value": 3,
    "lat": -28.0971316,
    "lng": 153.3992325
  },
  {
    "name": "Veresdale Scrub",
    "value": 1,
    "lat": -27.9190925,
    "lng": 153.01650465691813
  },
  {
    "name": "Verrierdale",
    "value": 1,
    "lat": -26.48833,
    "lng": 153.01889
  },
  {
    "name": "Victoria Point",
    "value": 12,
    "lat": -27.5843003,
    "lng": 153.300364
  },
  {
    "name": "Virginia",
    "value": 7,
    "lat": -27.3821745,
    "lng": 153.0624636
  },
  {
    "name": "Wacol",
    "value": 7,
    "lat": -27.589173,
    "lng": 152.9243501
  },
  {
    "name": "Wagtail Grove",
    "value": 3,
    "lat": -27.1036436,
    "lng": 152.8804129
  },
  {
    "name": "Wakerley",
    "value": 1,
    "lat": -27.4819726,
    "lng": 153.1617698
  },
  {
    "name": "Walloon",
    "value": 9,
    "lat": -27.6073451,
    "lng": 152.6679831
  },
  {
    "name": "Warana",
    "value": 6,
    "lat": -26.7198815,
    "lng": 153.131258125
  },
  {
    "name": "Wardell",
    "value": 1,
    "lat": -27.422938660562792,
    "lng": 152.99068472605816
  },
  {
    "name": "Warner",
    "value": 3,
    "lat": -27.90732215,
    "lng": 153.31311549144752
  },
  {
    "name": "Waterford",
    "value": 2,
    "lat": -27.705433,
    "lng": 153.131516
  },
  {
    "name": "Waterford West",
    "value": 5,
    "lat": -27.6910154,
    "lng": 153.125553
  },
  {
    "name": "Wavell Heights",
    "value": 19,
    "lat": -27.3958794,
    "lng": 153.048943
  },
  {
    "name": "Wellcamp",
    "value": 1,
    "lat": -27.556935199999998,
    "lng": 151.7927588644322
  },
  {
    "name": "Wellington Point",
    "value": 11,
    "lat": -27.494379,
    "lng": 153.2417439
  },
  {
    "name": "West End",
    "value": 8,
    "lat": -27.4832994,
    "lng": 153.0075017
  },
  {
    "name": "West Ipswich",
    "value": 1,
    "lat": -27.6196145,
    "lng": 152.7482435
  },
  {
    "name": "White Rock",
    "value": 3,
    "lat": -27.6943743,
    "lng": 152.8481144
  },
  {
    "name": "Widgee",
    "value": 1,
    "lat": -26.2022035,
    "lng": 152.4382283
  },
  {
    "name": "Wights Mountain",
    "value": 1,
    "lat": -27.396895999999998,
    "lng": 152.84579997077662
  },
  {
    "name": "Willawong",
    "value": 4,
    "lat": -27.5980978,
    "lng": 153.005894
  },
  {
    "name": "Willow Vale",
    "value": 3,
    "lat": -27.8417192,
    "lng": 153.2686268
  },
  {
    "name": "Wilston",
    "value": 5,
    "lat": -27.4335826,
    "lng": 153.020154
  },
  {
    "name": "Windsor",
    "value": 2,
    "lat": -27.4346805,
    "lng": 153.0309963977168
  },
  {
    "name": "Wishart",
    "value": 2,
    "lat": -27.5514355,
    "lng": 153.1031592
  },
  {
    "name": "Witheren",
    "value": 1,
    "lat": -28.036371000000003,
    "lng": 153.19736391902137
  },
  {
    "name": "Woodend",
    "value": 2,
    "lat": -27.6071641,
    "lng": 152.7524694
  },
  {
    "name": "Woodford",
    "value": 13,
    "lat": -26.954697,
    "lng": 152.7777428
  },
  {
    "name": "Woodhill",
    "value": 1,
    "lat": -27.886709,
    "lng": 152.97209158211206
  },
  {
    "name": "Woodridge",
    "value": 3,
    "lat": -27.6325507,
    "lng": 153.104227
  },
  {
    "name": "Woody Point",
    "value": 6,
    "lat": -27.2585089,
    "lng": 153.103077
  },
  {
    "name": "Woolloongaba",
    "value": 1,
    "lat": -22.1646782,
    "lng": 144.5844903
  },
  {
    "name": "Woolloongabba",
    "value": 12,
    "lat": -27.492784999999998,
    "lng": 153.0383019945906
  },
  {
    "name": "Wooloowin",
    "value": 7,
    "lat": -27.4194368,
    "lng": 153.0412308
  },
  {
    "name": "Woombye",
    "value": 4,
    "lat": -26.660559,
    "lng": 152.97806733110392
  },
  {
    "name": "Woongoolba",
    "value": 1,
    "lat": -27.731316,
    "lng": 153.3054403422696
  },
  {
    "name": "Woorim",
    "value": 3,
    "lat": -27.0699728,
    "lng": 153.203344
  },
  {
    "name": "Worongary",
    "value": 8,
    "lat": -28.0360735,
    "lng": 153.339128
  },
  {
    "name": "Wulkuraka",
    "value": 2,
    "lat": -27.6144977,
    "lng": 152.7273342
  },
  {
    "name": "Wurtulla",
    "value": 4,
    "lat": -26.7568243,
    "lng": 153.1256125
  },
  {
    "name": "Wynnum",
    "value": 10,
    "lat": -27.437718699999998,
    "lng": 153.16597426908976
  },
  {
    "name": "Wynnum West",
    "value": 8,
    "lat": -27.4539766,
    "lng": 153.1562022
  },
  {
    "name": "Yamanto",
    "value": 3,
    "lat": -27.6518749,
    "lng": 152.7446602
  },
  {
    "name": "Yamba",
    "value": 1,
    "lat": -15.1285028,
    "lng": 144.9760417
  },
  {
    "name": "Yandina",
    "value": 9,
    "lat": -26.5658945,
    "lng": 152.95961140508052
  },
  {
    "name": "Yandina Creek",
    "value": 1,
    "lat": -26.5303925,
    "lng": 153.0260482
  },
  {
    "name": "Yaroomba",
    "value": 2,
    "lat": -26.553937,
    "lng": 153.09563070708742
  },
  {
    "name": "Yarrabilba",
    "value": 14,
    "lat": -27.8030098,
    "lng": 153.1081584
  },
  {
    "name": "Yarraman",
    "value": 1,
    "lat": -26.829384,
    "lng": 151.98573502544588
  },
  {
    "name": "Yatala",
    "value": 6,
    "lat": -27.7352654,
    "lng": 153.2252177
  },
  {
    "name": "Yeerongpilly",
    "value": 13,
    "lat": -27.5239023,
    "lng": 153.0137075
  },
  {
    "name": "Yeronga",
    "value": 4,
    "lat": -27.517806,
    "lng": 153.0168916
  },
  {
    "name": "Yugar",
    "value": 2,
    "lat": -27.341970500000002,
    "lng": 152.87262200268134
  },
  {
    "name": "Zillmere",
    "value": 4,
    "lat": -27.3587634,
    "lng": 153.0376968
  },
  {
    "name": "condong",
    "value": 1,
    "lat": -27.5393067,
    "lng": 153.0953112
  }
];
